
namespace TabAurous.ProductDevelopment {

    @Serenity.Decorators.registerClass()
    export class DesignRequestGrid extends _Ext.GridBase<DesignRequestRow, any> {
        protected getColumnsKey() { return 'ProductDevelopment.DesignRequest'; }
        protected getDialogType() { return DesignRequestDialog; }
        protected getIdProperty() { return DesignRequestRow.idProperty; }
        protected getInsertPermission() { return DesignRequestRow.insertPermission; }
        protected getLocalTextPrefix() { return DesignRequestRow.localTextPrefix; }
        protected getService() { return DesignRequestService.baseUrl; }

        constructor(container: JQuery) {
            super(container);

        }
        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(101);
            var refno = FormatHelper.GetFormats("RefNo");
            var userDefinition = Q.Authorization.userDefinition;
            this.editItem(<DesignRequestRow>{ 
                Line_No: 0,
                VoucherTypeId: 101,
                CompanyId: userDefinition.CompanyId, 
                TransDate: now.toDateString(),
                Iteration: "01",
                RefNo: refno
            });
        }

    }
}